import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import {
  ChatContact,
  ChatMsg,
  SendMsgEventData,
} from "../../models/chat.model";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { keyCodes } from "../../models/key-codes.model";
import { ChatMessage } from "aws-sdk/clients/connect";
import { AuthService } from "../../services/auth.service";
import { SharedService } from "../../services/shared.service";
import { Popover, PopoverModule } from "primeng/popover";
import { CommonModule } from "@angular/common";
import { EmojiComponent, EmojiModule } from "@ctrl/ngx-emoji-mart/ngx-emoji";
import { FormsModule } from "@angular/forms";
import { ModalPopupComponent } from "../ui/modal-popup.component";
import { MsgReadStatusComponent } from "src/app/inbox/order-summary/order-chat/msg-read-status/msg-read-status.component";
import { LoaderComponent } from "../ui/loader/loader.component";
// import { VideoPlayerComponent } from "@mintplayer/ng-video-player";
import { ViewChildren, QueryList } from "@angular/core";
// import { ECapability, EPlayerState } from "@mintplayer/player-provider";
import { PickerComponent } from "@ctrl/ngx-emoji-mart";
import { MarkdownConverterService } from '../../services/markdown-converter.service';
import { TextareaModule } from 'primeng/textarea';
import { MarkdownLinksDirective } from './markdown-links.directive';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: "chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.scss"],
  imports: [
    PopoverModule,
    CommonModule,
    EmojiModule,
    FormsModule,
    ModalPopupComponent,
    MsgReadStatusComponent,
    LoaderComponent,
    TranslateModule,
    // VideoPlayerComponent,
    PickerComponent,
    TextareaModule,
    MarkdownLinksDirective,
    MarkdownModule,
  ],
  standalone: true,
})
export class ChatComponent implements OnInit {
  // @ViewChildren(VideoPlayerComponent)
  // audioPlayers: QueryList<VideoPlayerComponent>;

  @Input() contact: ChatContact;
  @Input() forceLtr: boolean = false;
  @Input() disabled: boolean = false;
  @Output() onSendMsg = new EventEmitter<SendMsgEventData>();
  @Output() onChatRefreshRequest = new EventEmitter<any>();
  @Output() onFileClicked = new EventEmitter<ChatMsg>();
  @Output() onDeleteMsgClicked = new EventEmitter<ChatMsg>();
  @Output() onCreateTaskClicked = new EventEmitter<ChatMsg>();

  newMsg: ChatMsg = new ChatMsg();
  sending: boolean;
  chatLoading: boolean;
  keyCodes = keyCodes;
  displayMsgActionsBtn: boolean;
  curMsg: ChatMsg;
  allowDeleteMsg: boolean;
  displayChatTasks: boolean;
  displayReadStatus: boolean;
  displayReadStatusPopup: boolean;

  get newMsgPlaceholder(): string {
    return this.translateService.instant("translate.chat.newMsgPlaceholder");
  }

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private sharedService: SharedService,
    private cd: ChangeDetectorRef,
    private markdownConverter: MarkdownConverterService
  ) {
    this.allowDeleteMsg =
      this.authService.currentUser.authDetails.getBooleanValue(
        "ORDERS.DELETE_CHAT_MSG_ALLOWED_SW"
      );
    this.displayChatTasks =
      this.authService.currentUser.authDetails.getBooleanValue(
        "ORDERS.CHAT_TASKS_SW"
      );
    this.displayReadStatus = this.authService.currentUser.isLabUser;
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.scrollToBottom();
  }

  initAudio() {
    // this.cd.detectChanges();
    // let audioMsg = this.contact.messages.filter(
    //   (m) => m.contentType == "AUDIO"
    // );
    // setTimeout(() => {
    //   this.audioPlayers.forEach((p, idx) => {
    //     p.autoplay = false;
    //     p.height = 35;
    //     p.setUrl(audioMsg[idx].audioSrc);
    //     setTimeout(() => {
    //       p.playerState = EPlayerState.paused;
    //     }, 200);
    //   });
    // }, 300);
  }

  sendMsg() {
    if (!this.newMsg.msgText || this.newMsg.msgText.trim() === '') {
      return;
    }

    this.sending = true;

    let event = new SendMsgEventData();
    event.contact = this.contact;
    event.msg = this.newMsg;
    event.onSuccessCallback = this.onSendSuccess;
    event.onErrorCallback = this.onSendError;
    this.onSendMsg.emit(event);
  }

  onSendSuccess = () => {
    this.sending = false;
    this.newMsg = new ChatMsg();
    this.onChatRefresh();
  };

  onSendError = () => {
    this.sending = false;
  };

  onChatRefresh = () => {
    this.chatLoading = true;
    this.onChatRefreshRequest.emit(() => {
      this.chatLoading = false;
      setTimeout(() => {
        this.scrollToBottom();
      }, 50);
    });
  };

  scrollToBottom = () => {
    var objDiv = document.getElementById(
      "chatHistory-" + this.contact.contactId
    );
    if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
  };

  onKeyPress(e: KeyboardEvent) {
    if (e.keyCode == keyCodes.enter) {
      if (e.shiftKey) {
        // Shift+Enter: Insert new line
        e.preventDefault();
        this.insertTextAtCursor('\n');
      } else {
        // Enter: Send message
        e.preventDefault();
        this.sendMsg();
      }
    }
  }

  onPaste(e: ClipboardEvent) {
    e.preventDefault();

    // Get the pasted content
    const htmlContent = e.clipboardData?.getData('text/html');
    const plainText = e.clipboardData?.getData('text/plain');

    if (htmlContent && htmlContent.trim()) {
      // Convert HTML to markdown
      console.log('Original HTML:', htmlContent);
      const markdownText = this.markdownConverter.htmlToMarkdown(htmlContent);
      console.log('Converted Markdown:', markdownText);
      this.insertTextAtCursor(markdownText);
    } else if (plainText) {
      // Insert plain text as is
      this.insertTextAtCursor(plainText);
    }
  }

  private insertTextAtCursor(text: string) {
    const textarea = document.getElementById(`txt_${this.contact.contactId}`) as HTMLTextAreaElement;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const currentValue = textarea.value;

    const newValue = currentValue.substring(0, start) + text + currentValue.substring(end);
    this.newMsg.msgText = newValue;

    // Set cursor position after the inserted text
    setTimeout(() => {
      textarea.setSelectionRange(start + text.length, start + text.length);
      textarea.focus();
    }, 0);
  }

  openFile(msg: ChatMsg) {
    this.onFileClicked.emit(msg);
  }

  deleteMsg(msg: ChatMsg) {
    let validationStr = this.translateService.instant(
      "translate.chat.deleteChatMsgValidation"
    );

    this.sharedService.emitPopupchReceivedEvent({
      title: "translate.chat.deleteChatMsgPrompt",
      icon: "exclamation-triangle",
      subTitle: validationStr,
      keep: false,
      approve: () => {
        this.onDeleteMsgClicked.emit(msg);
      },
    });
  }

  onMsgClicked(msg: ChatMsg) {
    if (this.curMsg == msg) {
      this.curMsg = null;
      this.displayMsgActionsBtn = false;
    } else {
      this.curMsg = msg;
      this.displayMsgActionsBtn = true;
    }
  }

  createTask(msg: ChatMsg) {
    this.displayMsgActionsBtn = false;
    this.curMsg = null;
    this.onCreateTaskClicked.emit(msg);
  }

  addEmoji($event, overlaypanel: Popover) {
    if (!this.newMsg.msgText) {
      this.newMsg.msgText = "";
    }
    // Add emoji as plain text for better compatibility
    this.newMsg.msgText += " " + $event.emoji.native;
    overlaypanel.hide();
  }

  msgReadByTarget(msg: ChatMsg) {
    if (this.contact.contactId == "PLANT") {
      return (
        msg.seenBy.filter((c) => c.userOrg == "PLANT").length > 0 ||
        msg.fromType == "PLANT"
      );
    } else {
      return (
        msg.seenBy.filter((c) => c.userOrg == "CLINIC").length > 0 ||
        msg.fromType == "CLINIC"
      );
    }
  }

  getTextDirection(text: string): 'ltr' | 'rtl' | 'auto' {
    if (!text || text.trim() === '') {
      return 'auto';
    }

    // Remove markdown syntax to check the actual text content
    const cleanText = text.replace(/[*_`#\[\]()]/g, '').trim();

    if (!cleanText) {
      return 'auto';
    }

    // Check if the text starts with Hebrew, Arabic, or other RTL characters
    const rtlRegex = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

    // Get the first non-whitespace character
    const firstChar = cleanText.match(/\S/)?.[0];

    if (firstChar && rtlRegex.test(firstChar)) {
      return 'rtl';
    }

    return 'ltr';
  }
}
